import { render, staticRenderFns } from "./StrokeDashIcon.vue?vue&type=template&id=afb8d142&"
import script from "./StrokeDashIcon.vue?vue&type=script&lang=js&"
export * from "./StrokeDashIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports